import React from "react";
import { useLang } from "@/i18n";
import { useContent } from "@/content";
import { Reveal, Eyebrow } from "@/components/Reveal";

const MediaItem = ({ src, testid, tall }) =>
  src.endsWith(".mp4") ? (
    <video
      src={src}
      autoPlay
      muted
      loop
      playsInline
      className={`img-spotlight w-auto max-w-none object-cover border hairline ${tall ? "h-64 sm:h-96" : "h-52 sm:h-72"}`}
      data-testid={testid}
    />
  ) : (
    <img
      src={src}
      alt="Obsidian Private Driver nelle Dolomiti"
      className={`img-spotlight w-auto max-w-none object-cover border hairline ${tall ? "h-64 sm:h-96" : "h-52 sm:h-72"}`}
      data-testid={testid}
    />
  );

export default function Gallery() {
  const { t } = useLang();
  const { content } = useContent();
  const g = content && content.gallery;
  if (!g) return null;
  const imgs = g.images || [];
  const half = Math.ceil(imgs.length / 2);
  const row1 = [...imgs.slice(0, half), ...imgs.slice(0, half)];
  const row2 = [...imgs.slice(half), ...imgs.slice(half)];

  return (
    <section className="relative py-24 sm:py-32 lg:py-36" data-testid="gallery-section">
      <div className="mx-auto mb-14 max-w-7xl px-6 sm:px-10 lg:px-16">
        <Reveal>
          <Eyebrow>{t(g.kicker)}</Eyebrow>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display mt-6 text-3xl font-light leading-tight text-[#FAF9F6] sm:text-4xl" data-testid="gallery-title">
            {t(g.title)}
          </h2>
        </Reveal>
      </div>

      <div className="flex flex-col gap-4 overflow-hidden sm:gap-6">
        <div className="marquee-paused relative flex overflow-hidden">
          <div className="animate-marquee flex shrink-0 gap-4 pr-4 sm:gap-6 sm:pr-6" style={{ "--marquee-duration": "75s" }}>
            {row1.map((src, i) => (
              <MediaItem key={i} src={src} testid={i < imgs.slice(0, half).length ? `gallery-row1-${i}` : undefined} />
            ))}
          </div>
        </div>
        <div className="marquee-paused relative flex overflow-hidden">
          <div className="animate-marquee-reverse flex shrink-0 gap-4 pr-4 sm:gap-6 sm:pr-6" style={{ "--marquee-duration": "85s" }}>
            {row2.map((src, i) => (
              <MediaItem key={i} src={src} tall testid={i < imgs.slice(half).length ? `gallery-row2-${i}` : undefined} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
